import { PortalChatMessage } from 'types/aiChat';
import { ToolPart, getToolName, isToolPart } from './toolCallParts';

const MEETING_PREP_TOOL_NAME = 'generateMeetingPrep';
const GROUP_MEETING_PREP_TOOL_NAME = 'generateGroupMeetingPrep';

export const hasMeetingPrepMarker = (message: PortalChatMessage): boolean => {
    return message.parts.filter(isToolPart).some((part) => {
        const tp = part as unknown as ToolPart;
        const toolName = getToolName(tp);
        return (
            (toolName === MEETING_PREP_TOOL_NAME || toolName === GROUP_MEETING_PREP_TOOL_NAME) &&
            (tp.state === 'output-available' || tp.state === 'result')
        );
    });
};
